import IPage from "interfaces/page";
import { useAppSelector } from "app/hooks";
import AuthHeader from "features/authHeader/AuthHeader";
import ResetPasswordForm from "features/resetPassword/ResetPasswordForm";
import { selectStatus } from "features/resetPassword/resetPasswordSlice";
import EnterNewPassword from "features/resetPassword/EnterNewPassword";
import ResetComplete from "features/resetPassword/ResetComplete";
import FullscreenContainer from "features/containers/FullscreenContainer";

const ResetPassword: React.FC<IPage> = () => {
  const resetStatus = useAppSelector(selectStatus);

  return (
    <FullscreenContainer sx={{ bgcolor: "primary.main" }}>
      <AuthHeader />
      {resetStatus === "idle" && <ResetPasswordForm />}
      {resetStatus === "emailSent" && <EnterNewPassword />}
      {resetStatus === "done" && <ResetComplete />}
    </FullscreenContainer>
  );
};

export default ResetPassword;
